"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Button = _interopRequireDefault(require("../../../Button"));
var _Stack = _interopRequireDefault(require("../../../Stack"));
var _utils = require("../../utils");
var _ItemWrapper = _interopRequireDefault(require("../ItemWrapper"));
var _Day = _interopRequireDefault(require("./Day"));
var _WeekDay = _interopRequireDefault(require("./WeekDay"));
var _intlTs = require("@gogame/intl-ts");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CalendarView = function CalendarView(_ref) {
  var onDateSelect = _ref.onDateSelect,
    current = _ref.current,
    isDateSelected = _ref.isDateSelected,
    isDateDisabled = _ref.isDateDisabled,
    showDaysOutsideCurrentMonth = _ref.showDaysOutsideCurrentMonth,
    renderDay = _ref.renderDay,
    onDateFocus = _ref.onDateFocus,
    onDateHover = _ref.onDateHover,
    focusedDate = _ref.focusedDate,
    _ref$isDateHighlighte = _ref.isDateHighlighted,
    isDateHighlighted = _ref$isDateHighlighte === void 0 ? function () {
      return false;
    } : _ref$isDateHighlighte,
    _ref$isDateHighlightS = _ref.isDateHighlightStart,
    isDateHighlightStart = _ref$isDateHighlightS === void 0 ? function () {
      return false;
    } : _ref$isDateHighlightS,
    _ref$isDateHighlightE = _ref.isDateHighlightEnd,
    isDateHighlightEnd = _ref$isDateHighlightE === void 0 ? function () {
      return false;
    } : _ref$isDateHighlightE,
    withTodayButton = _ref.withTodayButton;
  var todayDate = (0, _utils.getToday)();
  var currentMonthNumber = (0, _utils.getMonth)(current);
  var emitChangeFocusedDate = function emitChangeFocusedDate(date) {
    if (!isDateDisabled(date)) {
      onDateFocus(date);
    }
  };
  var keyDownHandler = (0, _utils.useKeyDownHandler)(true, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _utils.keycode.ArrowUp, function () {
    return emitChangeFocusedDate((0, _utils.addDays)(focusedDate, -7));
  }), _utils.keycode.ArrowDown, function () {
    return emitChangeFocusedDate((0, _utils.addDays)(focusedDate, 7));
  }), _utils.keycode.ArrowLeft, function () {
    return emitChangeFocusedDate((0, _utils.addDays)(focusedDate, -1));
  }), _utils.keycode.ArrowRight, function () {
    return emitChangeFocusedDate((0, _utils.addDays)(focusedDate, 1));
  }), _utils.keycode.Home, function () {
    return emitChangeFocusedDate((0, _utils.startOfWeek)(focusedDate));
  }), _utils.keycode.End, function () {
    return emitChangeFocusedDate((0, _utils.endOfWeek)(focusedDate));
  }));
  var focusedMonth = (0, _utils.isSameMonth)(current, focusedDate);
  var handleSelectToday = function handleSelectToday() {
    return onDateSelect(todayDate);
  };
  var dateFormat = (0, _intlTs.useDateFormat)({
    template: "yyyy-MM-dd",
    timeZone: "local"
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
    onKeyDown: keyDownHandler,
    direction: "row",
    flexWrap: "wrap",
    alignContent: "stretch",
    justifyContent: "center",
    margin: "4px auto 0",
    width: 286,
    minHeight: 280,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack["default"], {
      direction: "row",
      alignItems: "center",
      justifyContent: "center",
      children: (0, _utils.getWeekdays)().map(function (day) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_WeekDay["default"], {
          day: day
        }, day.toString());
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      role: "grid",
      children: (0, _utils.getWeekArray)(current).map(function (week) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack["default"], {
          role: "row",
          direction: "row",
          justifyContent: "center",
          children: week.map(function (day) {
            var disabled = isDateDisabled(day);
            var selected = isDateSelected(day);
            var isDayInCurrentMonth = (0, _utils.getMonth)(day) === currentMonthNumber;
            var focused = (0, _utils.isSameDay)(day, focusedDate);
            var today = (0, _utils.isSameDay)(day, todayDate);
            var highlight = isDateHighlighted(day) && isDayInCurrentMonth;
            var weekStart = (0, _utils.isStartOfWeek)(day);
            var weekEnd = (0, _utils.isEndOfWeek)(day);
            var monthStart = (0, _utils.isStartOfMonth)(day);
            var monthEnd = (0, _utils.isEndOfMonth)(day);
            var firstDateInLine = weekStart || monthStart || isDateHighlightStart(day);
            var lastDateInLine = weekEnd || monthEnd || isDateHighlightEnd(day);
            var tabIndex = focused || !focusedMonth && monthStart ? 0 : -1;
            var dayProps = {
              "data-cy-value": dateFormat(day),
              "data-cy-role": today ? "today" : null,
              "data-cy-state": selected ? "selected" : null,
              day: day,
              disabled: disabled,
              today: today,
              hidden: !isDayInCurrentMonth,
              isInCurrentMonth: isDayInCurrentMonth,
              selected: selected,
              showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
              onFocus: function onFocus() {
                return emitChangeFocusedDate(day);
              },
              focused: focused,
              tabIndex: tabIndex
            };
            var dayComponent = renderDay ? renderDay(day, dayProps) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Day["default"], _objectSpread({}, dayProps));
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ItemWrapper["default"], {
              value: day,
              onSelect: onDateSelect,
              disabled: disabled || !isDayInCurrentMonth && !showDaysOutsideCurrentMonth,
              highlight: highlight,
              firstDateInLine: firstDateInLine,
              lastDateInLine: lastDateInLine,
              radius: "50%",
              onMouseEnter: onDateHover ? function () {
                return onDateHover(day);
              } : undefined,
              children: dayComponent
            }, day.toString());
          })
        }, "week-".concat(week[0].toString()));
      })
    }), withTodayButton ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack["default"], {
      direction: "row",
      flex: "1 0 auto",
      justifyContent: "right",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button["default"], {
        onClick: handleSelectToday,
        variant: "outlined",
        color: "primary",
        disabled: isDateDisabled(todayDate),
        children: "Today"
      })
    }) : null]
  });
};
var _default = exports["default"] = CalendarView;